import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyForwardings, SupplyForwarding } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './supplyForwardingsModuleConfig';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<SupplyForwarding> useData={useSupplyForwardings} config={config} />;
};

export default List;
